/**
 *
 * @param {any} str
 */
function log(str) {
    console.log(JSON.stringify(str, undefined, 4))
}

/**
 * convert object to string
 * @param {any} obj object
 * @returns {string}
 */
function obj2str(obj) {
    if (Array.isArray(obj)) {
        return JSON.stringify(
            obj.map(function (idx) {
                return obj2str(idx)
            })
        )
    } else if (typeof obj === "object" && obj !== null) {
        var elements = Object.keys(obj)
            .sort()
            .map(function (key) {
                var val = obj2str(obj[key])
                if (val) {
                    return key + ":" + val
                }
            })

        var elementsCleaned = []
        for (var i = 0; i < elements.length; i++) {
            if (elements[i]) elementsCleaned.push(elements[i])
        }

        return "{" + elementsCleaned.join("|") + "}"
    }

    if (obj) return obj
}

/**
 * clear SSR cache
 */
function clearSSRCache() {
    var info = context.db.deleteMany("ssr", {})
    context.response.header("X-SSR-Cleared", info.removed)
}
/**
 *
 * @param {String} path
 * @returns {String}
 */
function getInternationalizedUrl(path) {
    const defaultLang = "de"
    const availableLanguages = ["de", "en"]

    if (!path || path === "/") return `/${defaultLang}`
    if (!path.startsWith("/")) path = "/" + path

    const segments = path.split("/").slice(1)

    if (availableLanguages.includes(segments[0])) {
        const url = `/${segments.join("/")}`
        return url.endsWith("/") ? url.slice(0, -1) : url
    }

    const restPath = segments.join("/")
    return `/${defaultLang}/${restPath}`
}
module.exports = {
    log,
    clearSSRCache,
    obj2str,
    getInternationalizedUrl,
}
